module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_8004.b2536d69.png";